/**
 * ¿Está abierta la pestaña Comunidad? Es el ÚNICO lugar que decide eso — lo leen la nav, el
 * `ComunidadGuard`, el pop-up de lanzamiento y el badge "Nuevo".
 *
 * Lanzada para TODAS las psicólogas (antes solo se veía impersonando). Se deja como función,
 * y no se borra el guard, para tener un único interruptor si hay que volver a cerrarla:
 * alcanza con que esto devuelva `false` (o `isImpersonated()` para la versión acotada).
 *
 * Ojo: el PANEL DE ADMIN de Comunidad sigue siendo solo para cuentas internas impersonando —
 * eso lo decide `checkComunidadAdminAccess` + el backend, no esta función.
 */
export function isComunidadEnabled(): boolean {
  return true;
}

/** Fin de la ventana del aviso de lanzamiento (pop-up + badge "Nuevo"): 13/10/2026 09:00 hora
 *  de Argentina. Para las psicólogas reales lo decide el backend (`eligible`); esta misma fecha
 *  está en `ComunidadLaunchService` (LAUNCH_ENDS_AT) y se usa acá para las sesiones
 *  impersonadas, que no pasan por el backend. Mantener las dos iguales. */
export const COMUNIDAD_LAUNCH_ENDS_AT_MS = Date.parse('2026-10-13T12:00:00.000Z');
